import { ppReactTheme } from './ppReactTheme';
import { controlTheme } from './controlTheme';
import { appStore } from '@/store';
import type { PAYPAL_THEME_TYPES } from '@paypalcorp/pp-react-theme-weasley-v7';
import { PAYPAL_THEME } from '@paypalcorp/pp-react-theme-weasley-v7';

type ThemeMap = {
  [key: string]: AppTheme.WeasleyTheme | PAYPAL_THEME_TYPES;
};

// v6 stands for @paypalcorp/pp-react@6
// v7 stands for @paypalcorp/pp-react@7
const THEME_MAP: ThemeMap = {
  default: controlTheme,
  // M&C - modernize and converge
  ppReactTheme: ppReactTheme,
  ppReactV7: PAYPAL_THEME,
};

// Passing "key" parameter to this function can override the global theme
// set in UI states
export const getTheme = (key?: string): any => {
  const themeName = key || appStore.getState().ui.theme;

  // If themeName=controlTheme, then we return default
  return THEME_MAP[themeName] || THEME_MAP.default;
};
